import { createSlice, createAction } from '@reduxjs/toolkit'
import { MetricEventType } from '../api/metrics'
import {
  DatasetIdProviderMetric,
  GeocodeMetric,
  QuotaEventMetric,
  OnboardingItemMetric,
  EnrichCreatedEventMetricPayload
} from '../types'

const name = 'metrics'
const CREATE_MAP_METRIC_REQUEST = `${name}/create_map_metric_request`
const CREATE_TILESET_METRIC_REQUEST = `${name}/create_tileset_metric_request`
const ACCESS_IN_REQUEST = `${name}/access_in_request`
const REQUEST_ACCESS_IN_REQUEST = `${name}/request_access_in_request`
const CREATE_METRIC_REQUEST = `${name}/create_metric_request`
const LAUNCH_GEOCODE_TABLE_METRIC = `${name}/launch_geocode_table_metric`
const QUOTA_EVENT_REQUEST = `${name}/quota_event_request`
const ONBOARDING_ITEM_CHECKED_EVENT_REQUEST = `${name}/onboarding_item_checked_event_request`
const FEATURED_UPDATE_OPENED_EVENT_REQUEST = `${name}/featured_update_opened_event_request`
const DEMO_MAP_DUPLICATED_EVENT_REQUEST = `${name}/demo_map_duplicated_event_request`
const DEMO_WORKFLOW_DUPLICATED_EVENT_REQUEST = `${name}/demo_workflow_duplicated_event_request`
const ANALYSIS_CREATED_EVENT_REQUEST = `${name}/analysis_created_event_request`
const CREATE_ENRICH_METRIC_REQUEST = `${name}/create_enrich_event_request`

const asyncActions = {
  accessInMetricRequest: createAction<DatasetIdProviderMetric>(ACCESS_IN_REQUEST),
  createDOMapMetricRequest: createAction<DatasetIdProviderMetric>(CREATE_MAP_METRIC_REQUEST),
  requestAccessInMetricRequest: createAction<DatasetIdProviderMetric>(REQUEST_ACCESS_IN_REQUEST),
  createTilesetMetricRequest: createAction<DatasetIdProviderMetric & { advancedMode; connectionId }>(
    CREATE_TILESET_METRIC_REQUEST
  ),
  createMetricRequest: createAction<MetricEventType>(CREATE_METRIC_REQUEST),
  launchGeocodeTableMetricRequest: createAction<GeocodeMetric>(LAUNCH_GEOCODE_TABLE_METRIC),
  quotaEventRequest: createAction<QuotaEventMetric>(QUOTA_EVENT_REQUEST),
  onboardingItemCheckedEventRequest: createAction<OnboardingItemMetric>(ONBOARDING_ITEM_CHECKED_EVENT_REQUEST),
  featuredUpdateOpenedEventRequest: createAction<OnboardingItemMetric>(FEATURED_UPDATE_OPENED_EVENT_REQUEST),
  demoMapDuplicatedEventRequest: createAction<OnboardingItemMetric>(DEMO_MAP_DUPLICATED_EVENT_REQUEST),
  demoWorkflowDuplicatedEventRequest: createAction<OnboardingItemMetric>(DEMO_WORKFLOW_DUPLICATED_EVENT_REQUEST),
  analysisCreatedEventRequest: createAction<OnboardingItemMetric>(ANALYSIS_CREATED_EVENT_REQUEST),
  createEnrichMetricRequest: createAction<EnrichCreatedEventMetricPayload>(CREATE_ENRICH_METRIC_REQUEST)
}

export const JobsImportingSlice = createSlice({
  name,
  initialState: {},
  reducers: {}
})

export const {
  createDOMapMetricRequest,
  createTilesetMetricRequest,
  accessInMetricRequest,
  requestAccessInMetricRequest,
  createMetricRequest,
  launchGeocodeTableMetricRequest,
  quotaEventRequest,
  onboardingItemCheckedEventRequest,
  featuredUpdateOpenedEventRequest,
  demoMapDuplicatedEventRequest,
  demoWorkflowDuplicatedEventRequest,
  analysisCreatedEventRequest,
  createEnrichMetricRequest
} = asyncActions

export default JobsImportingSlice.reducer
